import { isNonEmptyArray } from './isNonEmptyArray'

export const isAnyFilterApplied = ({ airSearchRequestModel, filterDefaults, forExdRequest = false }) => {
  const sliceFilters = airSearchRequestModel?.filter?.sliceFilters

  const filters = sliceFilters?.[0] || {}

  const { numOfStops, includedCarriers, origAirports, destAirports, timebands } = filters

  const defaultDestinationAirports = filterDefaults?.AIRPORTS?.[0]?.destinationAirports
  const defaultOriginalAirports = filterDefaults?.AIRPORTS?.[0]?.originAirports

  const stopsCondition = Number.isInteger(numOfStops) && numOfStops !== 7

  const airlineCondition = includedCarriers?.length > 0

  let airPortsCondition = origAirports?.length > 0 || destAirports?.length > 0

  if (
    origAirports?.length === defaultOriginalAirports?.length &&
    destAirports?.length === defaultDestinationAirports?.length
  ) {
    airPortsCondition = false
  }

  const takeOffBadgeCondition = timebands?.[0]?.takeoff || []
  const landingBadgeCondition = timebands?.[0]?.landing || []
  const timeCondition = isNonEmptyArray(takeOffBadgeCondition) || isNonEmptyArray(landingBadgeCondition)

  const attributes = sliceFilters?.find((i) => i?.sliceId === 1)?.attributes

  let attributeCondition = attributes?.length > 0

  if (forExdRequest && attributes?.length === 1 && attributes?.[0] === 'CARRY_ON') {
    attributeCondition = false
  }

  return Boolean(
    airPortsCondition || stopsCondition || airlineCondition || timeCondition || attributeCondition
  )
}
